/**
 * Size design tokens for height/width properties.
 *
 * These tokens share the same scale as spacing tokens but are semantically
 * intended for element sizing (height, width, min-height, max-height, etc.)
 * rather than spacing (padding, margin, gap).
 */
// Vertical size tokens (CSS var references for use in FAST css`` tagged templates)
export const sizeVerticalNone = "var(--sizeVerticalNone)";
export const sizeVerticalXXS = "var(--sizeVerticalXXS)";
export const sizeVerticalXS = "var(--sizeVerticalXS)";
export const sizeVerticalSNudge = "var(--sizeVerticalSNudge)";
export const sizeVerticalS = "var(--sizeVerticalS)";
export const sizeVerticalMNudge = "var(--sizeVerticalMNudge)";
export const sizeVerticalM = "var(--sizeVerticalM)";
export const sizeVerticalL = "var(--sizeVerticalL)";
export const sizeVerticalXL = "var(--sizeVerticalXL)";
export const sizeVerticalXXL = "var(--sizeVerticalXXL)";
export const sizeVerticalXXXL = "var(--sizeVerticalXXXL)";
// Horizontal size tokens (CSS var references for use in FAST css`` tagged templates)
export const sizeHorizontalNone = "var(--sizeHorizontalNone)";
export const sizeHorizontalXXS = "var(--sizeHorizontalXXS)";
export const sizeHorizontalXS = "var(--sizeHorizontalXS)";
export const sizeHorizontalSNudge = "var(--sizeHorizontalSNudge)";
export const sizeHorizontalS = "var(--sizeHorizontalS)";
export const sizeHorizontalMNudge = "var(--sizeHorizontalMNudge)";
export const sizeHorizontalM = "var(--sizeHorizontalM)";
export const sizeHorizontalL = "var(--sizeHorizontalL)";
export const sizeHorizontalXL = "var(--sizeHorizontalXL)";
export const sizeHorizontalXXL = "var(--sizeHorizontalXXL)";
export const sizeHorizontalXXXL = "var(--sizeHorizontalXXXL)";
/**
 * Size token values for theme object merging.
 * These values are theme-independent (same in light and dark modes)
 * and map 1:1 with the spacing token scale.
 *
 * When merged into theme objects, `setTheme()` will create corresponding
 * CSS custom properties (e.g., `--sizeVerticalXXL: 24px`).
 */
export const fabricSizeTokenValues = {
    sizeVerticalNone: "0",
    sizeVerticalXXS: "2px",
    sizeVerticalXS: "4px",
    sizeVerticalSNudge: "6px",
    sizeVerticalS: "8px",
    sizeVerticalMNudge: "10px",
    sizeVerticalM: "12px",
    sizeVerticalL: "16px",
    sizeVerticalXL: "20px",
    sizeVerticalXXL: "24px",
    sizeVerticalXXXL: "32px",
    sizeHorizontalNone: "0",
    sizeHorizontalXXS: "2px",
    sizeHorizontalXS: "4px",
    sizeHorizontalSNudge: "6px",
    sizeHorizontalS: "8px",
    sizeHorizontalMNudge: "10px",
    sizeHorizontalM: "12px",
    sizeHorizontalL: "16px",
    sizeHorizontalXL: "20px",
    sizeHorizontalXXL: "24px",
    sizeHorizontalXXXL: "32px"
};
